import { useDispatch, useSelector } from "react-redux";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { ExperienceDto, ExperienceListDto } from "@intelligems/ig-types";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import {
  getDialogPropDetails,
  isDialogOpen,
  setDialog,
} from "@src/store/slices/global";
import { FoundExperimentDetails } from "@src/types/experience";

interface RelatedPersonalizationActiveDialogProps {
  handleStartExperiment: (personalization: ExperienceListDto) => void;
}

export const RelatedPersonalizationActiveDialog = ({
  handleStartExperiment,
}: RelatedPersonalizationActiveDialogProps) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("relatedPersonalizationActive"));
  const dialogProps = useSelector(
    getDialogPropDetails("relatedPersonalizationActive")
  );

  const handleClose = () => {
    dispatch(
      setDialog({ dialog: "relatedPersonalizationActive", open: false })
    );
  };

  const handleYesClick = () => {
    handleStartExperiment(dialogProps?.experience);
    handleClose();
  };

  const contentText = (
    <IgTypography>
      The following active Experience
      {dialogProps?.isUsed.length > 1 ? "s:" : ""}{" "}
      {dialogProps?.isUsed.length > 1 ? (
        <ul style={{ margin: "0 auto", paddingLeft: "20px" }}>
          {dialogProps?.isUsed.map((used: FoundExperimentDetails) => (
            <li key={used.id}>{used.name}</li>
          ))}
        </ul>
      ) : (
        `${dialogProps?.isUsed[0].name}`
      )}{" "}
      may be generating visitor experiences that are very similar to those in
      this test. <br />
      <br />
      To avoid unpredictable visitor experiences, check the test before
      activating this Experience.
      <br />
      <br /> Are you sure you want to start this test?
    </IgTypography>
  );

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="xs"
      PaperProps={{
        sx: { padding: "10px" },
      }}
    >
      <DialogTitle sx={{ paddingBottom: 0 }}>
        Related Experience Active
      </DialogTitle>
      <DialogContent sx={{ marginTop: "20px" }}>{contentText}</DialogContent>
      <DialogActions sx={{ borderTop: "none" }}>
        <IgButton onClick={handleClose}>Cancel</IgButton>
        <IgButton onClick={handleYesClick} variant={"contained"}>
          Yes, start it
        </IgButton>
      </DialogActions>
    </Dialog>
  );
};
